export default __webpack_public_path__ + "static/media/img10.ee30074b.png";